import React from "react";
import { Col, Row } from "react-bootstrap";
import InputRotation from "../../../../../components/input/inputRotation";
import EraseButton from "../../../../../components/input/eraseButton";
import Gradient from "../../../../../components/input/inputColor/Gradient";
import InputGradientType from "../../../../../components/input/inputGradientType";
import { useDispatch, useSelector } from "react-redux";
import {
  resetGradientDots,
  reverseGradientDots,
  setGradientDotsColor,
  setGradientDotsRotation,
  setGradientDotsType,
} from "../../../../../redux/slices/qrSettings";

const QrPatternGradientColor = () => {
  const { gradientColors, gradientDotsType, gradientDotsRotation } =
    useSelector((state) => ({
      gradientColors: state.qrSettings.gradientDots.colorStops,
      gradientDotsType: state.qrSettings.gradientDots.type,
      gradientDotsRotation: state.qrSettings.gradientDots.rotation,
    }));

  const dispatch = useDispatch();

  return (
    <Row className="g-3">
      <Col md={8} lg={6}>
        <Gradient
          value={gradientColors[0].color}
          onChange={(color) =>
            dispatch(setGradientDotsColor({ order: 0, color }))
          }
          value2={gradientColors[1].color}
          onChange2={(color) =>
            dispatch(setGradientDotsColor({ order: 1, color }))
          }
          reverseColors={() => dispatch(reverseGradientDots())}
        />
      </Col>
      <Col xs={5} md={4} lg={3}>
        <InputGradientType
          value={gradientDotsType}
          onChange={(type) => dispatch(setGradientDotsType(type))}
        />
      </Col>
      <Col xs={7} md={6} lg={3}>
        <Row className="gx-3">
          <Col xs={8}>
            <InputRotation
              value={gradientDotsRotation}
              setRotation={(value) => dispatch(setGradientDotsRotation(value))}
            />
          </Col>
          <Col xs={4}>
            <EraseButton onClick={() => dispatch(resetGradientDots())} />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default QrPatternGradientColor;
